import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Categories from "../pages/categories/page";
import SearchPage from "../pages/search/page";
import SoftwareSaasAi from "../pages/categories/software-saas-ai/page";
import SoftwareSaasAiDetail from "../pages/categories/software-saas-ai/detail/page";
import FinanceInvestment from "../pages/categories/finance-investment/page";
import FinanceInvestmentDetail from "../pages/categories/finance-investment/detail/page";
import EcommerceShoppingPage from "../pages/categories/ecommerce-shopping/page";
import EcommerceShoppingDetail from "../pages/categories/ecommerce-shopping/detail/page";
import EducationLearningPage from "../pages/categories/education-learning/page";
import EducationLearningDetail from "../pages/categories/education-learning/detail/page";
import HealthFitnessWellnessPage from "../pages/categories/health-fitness-wellness/page";
import HealthFitnessWellnessDetail from "../pages/categories/health-fitness-wellness/detail/page";
import BeautyFashionLifestylePage from "../pages/categories/beauty-fashion-lifestyle/page";
import BeautyFashionLifestyleDetail from "../pages/categories/beauty-fashion-lifestyle/detail/page";
import HomeGardenDIYPage from "../pages/categories/home-garden-diy/page";
import HomeGardenDIYDetail from "../pages/categories/home-garden-diy/detail/page";
import GamingEntertainmentPage from "../pages/categories/gaming-entertainment/page";
import GamingEntertainmentDetail from "../pages/categories/gaming-entertainment/detail/page";
import TravelLifestylePage from "../pages/categories/travel-lifestyle/page";
import TravelLifestyleDetail from "../pages/categories/travel-lifestyle/detail/page";
import FamilyPetKidsPage from "../pages/categories/family-pet-kids/page";
import FamilyPetKidsDetail from "../pages/categories/family-pet-kids/detail/page";
import HostingPlatformsPage from "../pages/categories/hosting-platforms/page";
import HostingPlatformsDetail from "../pages/categories/hosting-platforms/detail/page";
import FoodBeveragePage from "../pages/categories/food-beverage/page";
import FoodBeverageDetail from "../pages/categories/food-beverage/detail/page";
import AutomotiveTransportationPage from "../pages/categories/automotive-transportation/page";
import AutomotiveTransportationDetail from "../pages/categories/automotive-transportation/detail/page";
import RealEstatePropertyPage from "../pages/categories/real-estate-property/page";
import RealEstatePropertyDetail from "../pages/categories/real-estate-property/detail/page";
import Reviews from "../pages/reviews/page";
import ReviewDetail from "../pages/reviews/detail/page";
import Blog from "../pages/blog/page";
import BlogDetail from "../pages/blog/detail/page";
import Comparisons from "../pages/comparisons/page";
import ComparisonDetail from "../pages/comparisons/detail/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import SubmitTool from "../pages/submit-tool/page";
import Advertise from "../pages/advertise/page";
import AdminPage from "../pages/admin/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/categories", element: <Categories /> },
  { path: "/search", element: <SearchPage /> },
  { path: "/categories/software-saas-ai", element: <SoftwareSaasAi /> },
  { path: "/categories/software-saas-ai/:slug", element: <SoftwareSaasAiDetail /> },
  { path: "/categories/finance-investment", element: <FinanceInvestment /> },
  { path: "/categories/finance-investment/:slug", element: <FinanceInvestmentDetail /> },
  { path: "/categories/ecommerce-shopping", element: <EcommerceShoppingPage /> },
  { path: "/categories/ecommerce-shopping/:slug", element: <EcommerceShoppingDetail /> },
  { path: "/categories/education-learning", element: <EducationLearningPage /> },
  { path: "/categories/education-learning/:slug", element: <EducationLearningDetail /> },
  { path: "/categories/health-fitness-wellness", element: <HealthFitnessWellnessPage /> },
  { path: "/categories/health-fitness-wellness/:slug", element: <HealthFitnessWellnessDetail /> },
  { path: "/categories/beauty-fashion-lifestyle", element: <BeautyFashionLifestylePage /> },
  { path: "/categories/beauty-fashion-lifestyle/:slug", element: <BeautyFashionLifestyleDetail /> },
  { path: "/categories/home-garden-diy", element: <HomeGardenDIYPage /> },
  { path: "/categories/home-garden-diy/:slug", element: <HomeGardenDIYDetail /> },
  { path: "/categories/gaming-entertainment", element: <GamingEntertainmentPage /> },
  { path: "/categories/gaming-entertainment/:slug", element: <GamingEntertainmentDetail /> },
  { path: "/categories/travel-lifestyle", element: <TravelLifestylePage /> },
  { path: "/categories/travel-lifestyle/:slug", element: <TravelLifestyleDetail /> },
  { path: "/categories/family-pet-kids", element: <FamilyPetKidsPage /> },
  { path: "/categories/family-pet-kids/:slug", element: <FamilyPetKidsDetail /> },
  { path: "/categories/hosting-platforms", element: <HostingPlatformsPage /> },
  { path: "/categories/hosting-platforms/:slug", element: <HostingPlatformsDetail /> },
  { path: "/categories/food-beverage", element: <FoodBeveragePage /> },
  { path: "/categories/food-beverage/:slug", element: <FoodBeverageDetail /> },
  { path: "/categories/automotive-transportation", element: <AutomotiveTransportationPage /> },
  { path: "/categories/automotive-transportation/:slug", element: <AutomotiveTransportationDetail /> },
  { path: "/categories/real-estate-property", element: <RealEstatePropertyPage /> },
  { path: "/categories/real-estate-property/:slug", element: <RealEstatePropertyDetail /> },
  { path: "/reviews", element: <Reviews /> },
  { path: "/reviews/:slug", element: <ReviewDetail /> },
  { path: "/blog", element: <Blog /> },
  { path: "/blog/:slug", element: <BlogDetail /> },
  { path: "/comparisons", element: <Comparisons /> },
  { path: "/comparisons/:slug", element: <ComparisonDetail /> },
  { path: "/about", element: <About /> },
  { path: "/contact", element: <Contact /> },
  { path: "/submit-tool", element: <SubmitTool /> },
  { path: "/advertise", element: <Advertise /> },
  { path: "/admin", element: <AdminPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
